import { createSlice } from "@reduxjs/toolkit";
import { packagesStateName, packagesInitialState } from "./constants";

const packagesSlice = createSlice({
  name: packagesStateName,
  initialState: packagesInitialState,
  reducers: {
    setPackages(state, action) {
      state.packages = action.payload;
    },
  },
});

export const { name, reducer, actions } = packagesSlice;
